export const ALERT_CONFIRMATION_MESSAGES = Object.freeze({
  deleteAlert: {
    title: "Delete Alert",
    message:
      "Deleting this alert will permanently remove the alert for everyone and remove it from Alert History.\n\nNote: Platform statuses will not change.",
  },
  resolveAlert: {
    title: "Resolve Alert",
    message:
      "Marking this alert as resolved will remove it from all users’ dashboards\n\nNote: Platform statuses will not change.",
  },
  deleteInfoMessage: {
    title: "Delete Info Message",
    message:
      "Deleting this info message will permanently remove it for everyone.",
  },
  resolveInfoMessage: {
    title: "Resolve Info Message",
    message:
      "Marking this info message as resolved will remove it from all users’ dashboards.",
  },
});
